
import {FC} from "react";

import React from 'react';

import ErrorExistsFirstForm from "../../forms/claim-handling-forms/error-exists-first-form";

interface Interface{
    partSource: any;
    requestId: any;
    mode?: "View" | "Add new";
    onClose?: () => void;
}

const ErrorExistsFirstScreen: FC<Interface> = (props:any) => {

    

    return (
            
                <ErrorExistsFirstForm
                    requestId={props.requestId}
                    partSource={props.partSource}
                    mode={props.mode}
                />
            
    );
}
export default ErrorExistsFirstScreen;
